import '../../App.css'
import 'leaflet/dist/leaflet.css'
import { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import CloseIcon from '@mui/icons-material/Close'

import '../../styles/index.scss'
import keycloak from '../../keycloak'
import { AuthContext } from '@contexts/Auth'
import { PermissionCodeEnum } from '@models/permission'
import { useTranslation } from 'react-i18next'
import { WorldMap } from '@components/map/WorldMap'
import ProfileMenu from '@components/map/ProfileMenu'
import { hasPermission } from '@utils/permission_helper'
import { newTitle } from '../../styles/newLogoTitle'
import { hasAiChatbotLandingAccess } from '../../config/landingAccess'

type LandingSystemLink = {
	label: string
	href: string
	requiresAccess?: boolean
}

const systemLinks: LandingSystemLink[] = [
	{
		label: 'Dashboard',
		href: 'https://auth.hkl-ifmct.cloud/realms/ifmct-platform/protocol/saml/clients/amazon-qs?kc_idp_hint=75e56285-8764-59bd-a46b-45fb534d7514',
	},
	{
		label: 'Digital Twin',
		href: 'https://platform.ct.centralhkl.com/',
	},
	{
		label: 'AI Chatbot',
		href: 'https://auth.hkl-ifmct.cloud/realms/ifmct-platform/protocol/openid-connect/auth?client_id=Dashboard%20Frontend&redirect_uri=https%3A%2F%2Fchatbot.hkl-ifmct.cloud&response_type=code&scope=openid&kc_idp_hint=75e56285-8764-59bd-a46b-45fb534d7514',
		requiresAccess: true,
	},
]

export const LandingPage = () => {
	const { state, dispatch } = useContext(AuthContext)
	const navigate = useNavigate()
	const { t } = useTranslation()
	const [isSystemSelectorOpen, setIsSystemSelectorOpen] = useState(true)
	const canCloseSystemSelector = hasPermission(state.userInfo, [PermissionCodeEnum.ConfigurationMenu])
	const canAccessAiChatbot = hasAiChatbotLandingAccess(
		state.userInfo.role_ids ?? [],
		state.userInfo.email,
	)

	document.title = t(newTitle)

	return (
		<>
			<div className="logo-wrapper">
				<img src={'img/hkland_logo.png'} alt="logo" />
			</div>
			<div className="function-btn-wrapper">
				<ProfileMenu
					handleLogout={() => {
						dispatch({ type: 'logout' })
						localStorage.clear()
						navigate('/')

						// UserService.CreateAuditTrail({
						// 	date: new Date().toISOString(),
						// 	message: 'Logout system',
						// 	eventType: 'LOGOUT',
						// 	status: 'SUCCESS',
						// }).finally(() => {
						// })

						keycloak.logout({ redirectUri: window.location.origin })
					}}
				/>
			</div>
			<WorldMap />
			{isSystemSelectorOpen ? (
				<div className="landing-system-modal-backdrop">
					<div
						className="landing-system-modal"
						role="dialog"
						aria-modal="true"
						aria-labelledby="landing-system-selector-title"
					>
						{canCloseSystemSelector ? (
							<button
								type="button"
								className="landing-system-modal__close"
								aria-label="Close system selector"
								onClick={() => setIsSystemSelectorOpen(false)}
							>
								<CloseIcon fontSize="small" />
							</button>
						) : null}
						<div className="landing-system-modal__panel">
							<div className="landing-system-modal__brand">
								<img
									className="landing-system-modal__brand-logo"
									src="/img/hkland_logo.png"
									alt="Hongkong Land logo"
								/>
								<h1
									id="landing-system-selector-title"
									className="landing-system-modal__brand-title landing-system-modal__brand-title--sr-only"
								>
									Hongkong Land
								</h1>
							</div>
							<div className="landing-system-modal__actions">
								{systemLinks.map((link) => (
									<a
										key={link.label}
										className={`landing-system-modal__link${
											link.requiresAccess && !canAccessAiChatbot
												? ' landing-system-modal__link--disabled'
												: ''
										}`}
										href={link.requiresAccess && !canAccessAiChatbot ? undefined : link.href}
										target={link.requiresAccess && !canAccessAiChatbot ? undefined : '_blank'}
										rel={link.requiresAccess && !canAccessAiChatbot ? undefined : 'noopener noreferrer'}
										role="link"
										aria-disabled={link.requiresAccess && !canAccessAiChatbot ? true : undefined}
										tabIndex={link.requiresAccess && !canAccessAiChatbot ? -1 : undefined}
									>
										{link.label}
									</a>
								))}
							</div>
						</div>
					</div>
				</div>
			) : null}
		</>
	)
}
